import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import React from "react";
import { useTrainerAutocompleteState } from "./state";

export interface Props {
  onChange: (trainer: racehorse360.ITrainer) => void;
  trainerAssistant?: boolean;
}

const TrainerAutocomplete = (props: Props) => {
  const { onChange, trainerAssistant } = props;

  const { open, setOpen, options, loading, setTrainerName } =
    useTrainerAutocompleteState();

  return (
    <Autocomplete<racehorse360.ITrainer>
      id="asynchronous-demo"
      style={{ width: 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={option =>
        `${option.firstName} ${option.lastName} (${option.type}-${option.trainerNumber}) (${option.horsesOnGround} horses)`
      }
      options={options}
      loading={loading}
      onChange={(event, value) => {
        onChange(value as racehorse360.ITrainer);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={trainerAssistant ? "For Trainer" : "Trainer Identity"}
          placeholder={trainerAssistant ? "For Trainer" : "Trainer Identity"}
          onChange={v => {
            setTrainerName(v.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
        />
      )}
    />
  );
};

export default TrainerAutocomplete;
